import axios from 'axios';
import { loginreq, req,reqPost } from './axiosFun';

// 登录接口 
export const login = (params) => { return loginreq("get", "/app-yijiu-backstage/login", params) };
// 获取用户菜单
export const menu = (params) => { return axios.get("/api/menu?&token=" + localStorage.getItem('logintoken')).then(res => res.data) };
// 退出接口
export const loginout = () => { return axios.delete("/api/login?&token=" + localStorage.getItem('logintoken')).then(res => res.data) };


/**
 * 用户管理 管理员
 **/
// 用户管理-获取用户列表
export const getUserList = (params) => { return req("get", "/app-yijiu-backstage/getUserList", params) };
export const addUser = (params) => { return req("get", "/app-yijiu-backstage/addUser", params) };
export const upUser = (params) => { return req("get", "/app-yijiu-backstage/upUser", params) };
export const deleteUser = (params) => { return req("get", "/app-yijiu-backstage/deleteUser", params) };


/**
 * 轮播图管理 
 **/
export const addCarousel = (params) => { return reqPost("/app-yijiu-backstage/addCarousel", params) };
export const upCarousel = (params) => { return reqPost( "/app-yijiu-backstage/upCarousel", params) };
export const deleteCarousel = (params) => { return reqPost("/app-yijiu-backstage/deleteCarousel", params) };
export const getCarouselList = (params) => { return reqPost( "/app-yijiu-backstage/getCarouselList", params) };

export const getVariableList = (params) => { return reqPost( "/app-yijiu-backstage/getVariableList", params) };
export const setVariable = (params) => { return reqPost( "/app-yijiu-backstage/setVariable", params) };









/**
 * 资讯分类管理
 **/
 export const addNewsClassify = (params) => { return req("post", "/app-yijiu-backstage/addNewsClassify", params) };
 export const upNewsClassify = (params) => { return req("post", "/app-yijiu-backstage/upNewsClassify", params) };
 export const deleteNewsClassify = (params) => { return req("post", "/app-yijiu-backstage/deleteNewsClassify", params) };
 export const getNewsClassifyList = (params) => { return req("post", "/app-yijiu-backstage/getNewsClassifyList", params) };
 
 /**
 * 资讯分类管理二级
 **/
  // export const addNewsClassifyTwo = (params) => { return req("post", "/app-yijiu-backstage/addNewsClassifyTwo", params) };
  export const addNewsClassifyTwo = (params) => { return reqPost("/app-yijiu-backstage/addNewsClassifyTwo", params) };
  // export const upNewsClassifyTwo = (params) => { return req("post", "/app-yijiu-backstage/upNewsClassifyTwo", params) };
  export const upNewsClassifyTwo = (params) => { return reqPost("/app-yijiu-backstage/upNewsClassifyTwo", params) };
  export const deleteNewsClassifyTwo = (params) => { return req("post", "/app-yijiu-backstage/deleteNewsClassifyTwo", params) };
  export const getNewsClassifyTwoList = (params) => { return req("post", "/app-yijiu-backstage/getNewsClassifyTwoList", params) };
  
/**
 * 资讯管理
 **/
    export const addNews = (params) => { return reqPost("/app-yijiu-backstage/addNews", params) };
    export const upNews = (params) => { return reqPost( "/app-yijiu-backstage/upNews", params) };
    export const deleteNews = (params) => { return req("get", "/app-yijiu-backstage/deleteNews", params) };
    export const getNewsList = (params) => { return req("get", "/app-yijiu-backstage/getNewsList", params) };
    
 
 /**
 * 用户管理
 **/
  export const getMemberList = (params) => { return reqPost("/app-yijiu-backstage/getMemberList", params) };
  export const getMemberListOnLine = (params) => { return reqPost("/app-yijiu-backstage/getMemberListOnLine", params) };
  
  export const setMemberStatus = (params) => { return reqPost("/app-yijiu-backstage/setMemberStatus", params) };
  export const getMemberFeedbackList = (params) => { return reqPost("/app-yijiu-backstage/getMemberFeedbackList", params) };


    
 /**
 * 平台协议内容
 **/
  export const upPlatformContent = (params) => { return reqPost("/app-yijiu-backstage/upPlatformContent", params) };
  export const getPlatformContentList = (params) => { return req("get", "/app-yijiu-backstage/getPlatformContentList", params) };

  
  
    
 /**
 * 订单管理
 **/
  export const getOrderDetails = (params) => { return req("get", "/app-yijiu-backstage/getOrderDetails", params) };
  export const getOrderList = (params) => { return req("post", "/app-yijiu-backstage/getOrderList", params) };
  export const setOrderRefund = (params) => { return req("get", "/app-yijiu-backstage/setOrderRefund", params) };
  export const affirmOrder = (params) => { return req("post", "/app-yijiu-backstage/affirmOrder", params) };


  
  export const getClassifyList = (params) => { return req("post", "/app-yijiu-member/getClassifyList", params) };
  export const getAdminCityNameData = (params) => { return req("get", "/app-yijiu-backstage/getAdminCityNameData", params) };
  export const getDashboardData = (params) => { return req("get", "/app-yijiu-backstage/getDashboardData", params) };

  export const getCityNameList = (params) => { return req("get", "/app-yijiu-backstage/getCityNameList", params) };

  
    
 /**
 * 技能审核
 **/
  export const getSkillAuditList = (params) => { return req("post", "/app-yijiu-backstage/getSkillAuditList", params) };
  export const getPendingSkillAuditCount = (params) => { return req("post", "/app-yijiu-backstage/getPendingSkillAuditCount", params) };
  export const getAdminNotificationSummary = (params) => { return req("post", "/app-yijiu-backstage/getAdminNotificationSummary", params) };
  export const setSkillStatus = (params) => { return reqPost("/app-yijiu-backstage/setSkillStatus", params) };
  export const getMemberSkillList = (params) => { return req("post", "/app-yijiu-backstage/getMemberSkillList", params) };


    
 /**
 * 财务管理
 **/
  export const getFinanceList = (params) => { return req("get", "/app-yijiu-backstage/getFinanceList", params) };
  export const getWithdrawList = (params) => { return req("get", "/app-yijiu-backstage/getWithdrawList", params) };
  export const setWithdraw = (params) => { return req("get", "/app-yijiu-backstage/setWithdraw", params) };
  export const setServiceCharge = (params) => { return req("get", "/app-yijiu-backstage/setServiceCharge", params) };
  export const getBailBalanceList = (params) => { return req("get", "/app-yijiu-backstage/getBailBalanceList", params) };
  export const refundBailBalance = (params) => { return req("get", "/app-yijiu-backstage/refundBailBalance", params) };


  
  
  

  


















/**
 * 用户管理 
 **/
// 用户管理-获取用户列表
export const userList = (params) => { return req("post", "/api/User/list", params) };
// 用户管理-保存（添加编辑）
export const userSave = (params) => { return req("post", "/api/User/save", params) };
// 用户管理-删除用户
export const userDelete = (params) => { return axios.delete("/api/User/delete?ids=" + params + "&token=" + localStorage.getItem('logintoken')).then(res => res.data) };
// 用户管理-重置密码
export const userPwd = (params) => { return req("post", "/api/User/pwd", params) };
// 用户管理-修改状态
export const userLock = (params) => { return axios.get("/api/User/lock?userId=" + params.userId + "&lock=" + params.lock + "&token=" + localStorage.getItem('logintoken')) };
// 用户管理-数据权限
export const UserDeptTree = (params) => { return axios.get("/api/UserDept/tree/" + params + "?token=" + localStorage.getItem('logintoken')) };
// 用户管理-数据权限保存
export const UserDeptSave = (params) => { return req("post", "/api/UserDept/save", params) };
// 用户管理-获取部门设置
export const UserDeptdeptTree = (params) => { return axios.get("/api/UserDept/deptTree/" + params + "?token=" + localStorage.getItem('logintoken')) };
// 用户管理-保存部门设置
export const UserChangeDept = (params) => { return req("post", "/api/User/change/dept", params) };
// 用户管理-用户下线
export const userExpireToken = (params) => { return req("get", "/api/User/expireToken/" + params, {}) };
// 用户管理-刷新缓存
export const userFlashCache = (params) => { return req("get", "/api/User/flashCache/" + params, {}) };

/**
 * 菜单管理
 **/
// 菜单管理-获取菜单Module/list
export const ModuleList = () => { return req("post", "/api/Module/list") };
// 菜单管理-根据菜单获取数据
export const ModuleGet = (params) => { return axios.get("/api/Module/get/" + params + "?token=" + localStorage.getItem('logintoken')) };
// 菜单管理-获取父级菜单Module/nodes
export const ModuleNodes = (params) => { return req("post", "/api/Module/nodes", params) };
// 菜单管理-修改菜单
export const ModuleSave = (params) => { return req("post", "/api/Module/save", params) };
// 菜单管理-删除菜单
export const ModuleDelete = (params) => { return axios.delete("/api/Module/delete?ids=" + params + "&token=" + localStorage.getItem('logintoken')).then(res => res.data) };

/**
 * 角色管理 
 **/
// 角色管理-获取角色列表
export const roleList = (params) => { return req("post", "/api/Role/list", params) };
// 角色管理-保存（添加编辑）
export const roleSave = (params) => { return req("post", "/api/Role/save", params) };
// 角色管理-删除角色
export const roleDelete = (params) => { return axios.delete("/api/Role/delete?ids=" + params + "&token=" + localStorage.getItem('logintoken')).then(res => res.data) };
// 角色管理-菜单权限（获取）
export const RoleRightTree = (params) => { return axios.get("/api/RoleRight/tree/" + params + "?token=" + localStorage.getItem('logintoken')) };
// 角色管理-菜单权限（保存）
export const RoleRightSave = (params) => { return req("post", "/api/RoleRight/save", params) };

/**
 * 公司管理 
 **/
// 公司管理-获取公司列表
export const deptList = (params) => { return req("post", "/api/Dept/list", params) };
// 公司管理-保存（添加编辑）
export const deptSave = (params) => { return req("post", "/api/Dept/save", params) };
// 公司管理-删除公司
export const deptDelete = (params) => { return axios.get("/api/Dept/delete?ids=" + params + "&token=" + localStorage.getItem('logintoken')).then(res => res.data) };

/**
 * 系统环境变量 
 **/
// 系统环境变量-获取系统环境变量列表
export const variableList = (params) => { return req("post", "/api/Variable/list", params) };
// 系统环境变量-保存（添加编辑）
export const variableSave = (params) => { return req("post", "/api/Variable/save", params) };
// 系统环境变量-删除系统环境变量
export const variableDelete = (params) => { return axios.delete("/api/Variable/delete?ids=" + params + "&token=" + localStorage.getItem('logintoken')).then(res => res.data) };

/**
 * 权限管理 
 **/
// 权限管理-获取权限列表
export const permissionList = (params) => { return req("post", "/api/Permission/list", params) };
// 权限管理-保存权限
export const ermissionSave = (params) => { return req("post", "/api/Permission/save", params) };
// 权限管理-删除权限
export const ermissionDelete = (params) => { return axios.delete("/api/Permission/delete?ids=" + params + "&token=" + localStorage.getItem('logintoken')).then(res => res.data) };
// 权限管理-获取权限
export const roleDropDown = () => { return axios.get("/api/Role/dropDown/all?&token=" + localStorage.getItem('logintoken')).then(res => res.data) };
// 权限管理-配置权限
export const RolePermission = (params) => { return req("post", "/api/RolePermission/save", params) };



// WEBPACK FOOTER //
// ./src/api/userMG.js